import React, { useState } from "react";
import "@frameworks/web/stylesheets/components/Reports/RevampedReports/TaxReport/ClearTaxBanner.scss";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import ClearTaxLogo from "@frameworks/web/assets/images/Reports/TAXReports/cleartaxlogo.svg";
import NuvamaNameLogo from "@frameworks/web/assets/images/generic/nuvama_name_logo.png";
import di from "@frameworks/web/components/Reports/RebrandedReports/TaxReport/di/servicelocator";
import { useSelector } from "react-redux";
import PopupFail from "@frameworks/web/components/Reports/HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import { getCurrentIndianFinancialYear, getPreviousIndianFinancialYear, } from "@domains/utils/reportDates";
import moment from "moment";
const ClearTaxBanner = (props) => {
    const device = DeviceContext();
    const accData = useSelector((state) => state.accountDetailsReducer);
    const [clearTaxFail, setClearTaxFail] = useState(false);
    const selectedMemberAccCode = useSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.FamilyTagging) === null || _a === void 0 ? void 0 : _a.familyDetails.reducersData) === null || _b === void 0 ? void 0 : _b.selectedMember) === null || _c === void 0 ? void 0 : _c.accCode; });
    const getCleartaxData = () => {
        const currYear = getCurrentIndianFinancialYear();
        const prevYear = getPreviousIndianFinancialYear();
        let FY = prevYear.startDate.format("YYYY");
        if (moment(props.startDate).isBetween(currYear.startDate, currYear.endDate, "year", "[]"))
            FY = currYear.startDate.subtract(1, "year").format("YYYY");
        else if (moment(props.startDate).isBetween(prevYear.startDate, prevYear.endDate, "year", "[]"))
            FY = prevYear.startDate.format("YYYY");
        else
            FY = moment(props.startDate).format("YYYY");
        let payload = {
            accountCode: accData.accountCode,
            userId: accData.userID,
            accountType: accData.accTyp,
            financialYear: FY.toString(),
        };
        let windowRef = window.open();
        di.taxReport
            .clearTax(payload)
            .then(function (res) {
            windowRef.location = res.redirectionURL;
        })
            .catch((err) => {
            setClearTaxFail(true);
        });
    };
    return (React.createElement("div", { className: "clear-tax-banner-body d-flex align-items-center  gap-3" },
        React.createElement("div", null,
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement("span", { className: "txt_blackOne1 pr-1 taxes-simplified" }, "Taxes simplified for you with"),
                React.createElement("img", { src: ClearTaxLogo, alt: "cleartax", className: "px-1 cleartaxlogo" }),
                React.createElement("span", { className: "px-1" },
                    React.createElement("i", { className: "edel-icon-clear-tax-cross cross-sign" })),
                React.createElement("img", { src: NuvamaNameLogo, alt: "Nuvama Wealth", className: "nuvama-logo" })),
            React.createElement("div", { className: "d-flex align-items-center gap-1" },
                React.createElement("span", { className: "terms-and-condition-proceeding" }, "By proceeding, you agree to the"),
                React.createElement("span", { className: "terms-and-condition", onClick: () => {
                        props.setClearTaxTermsAndConditionShow(true);
                    } }, "Terms and Conditions"))),
        React.createElement("div", null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(EdButton, { btnTyp: "white-one", value: "File with ClearTax", className: "clear-tax-btn DMSanM_14_500", disabled: selectedMemberAccCode !== accData.accountCode, onClick: () => getCleartaxData() })) : (React.createElement("div", { onClick: (e) => {
                e.stopPropagation();
                if (selectedMemberAccCode !== accData.accountCode)
                    getCleartaxData();
            }, className: "hand_cursor" },
            React.createElement("i", { className: "edel-icon-right-arrow txt-tomato" })))),
        (device === null || device === void 0 ? void 0 : device.isDesktop) ? (clearTaxFail && (React.createElement("div", { className: "modalBackground common-new-modal-designs" },
            React.createElement("div", { className: "modalContainer" },
                React.createElement(PopupFail, { setDownloadFail: setClearTaxFail, Title: "Clear Tax", operation: "", sendBack: true, isDownloadIcon: false, goBackText: true, message: `<span class='DMSans_16_500'>We ran in to some technical difficulties.</span>`, goBack: () => setClearTaxFail(false), reportText: true }))))) : (React.createElement(GenericDrawer, { show: clearTaxFail, setShow: setClearTaxFail, parentClass: "something-wrong-drawer", bodyComp: React.createElement("div", { className: "something-wrong" },
                React.createElement("div", { className: "something-wrong-body" },
                    React.createElement("div", { className: "DMSanM_14_500" }, "We ran in to some technical difficulties"),
                    React.createElement(EdButton, { onClick: () => {
                            setClearTaxFail(false);
                        }, btnTyp: "midnight-blue-underline", value: React.createElement(React.Fragment, null,
                            React.createElement("i", { className: "edel-icon-left-shortArrow twist" }),
                            React.createElement("span", null, "Go Back")) }))) }))));
};
export default ClearTaxBanner;
